/*eslint no-undef: "error"*/
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import ProgressiveImg from "app/pages/.shared/ProgressiveImg";
import get from "lodash/get";
import { connect } from "react-redux";

const IMG_SIZES = {
	large: { width: 1440 },
	xlarge: { width: 1440 },
	medium: { width: 1440 },
};

const IMG_SIZES_SMALL = {
	small: { width: 768 },
};

const ListingHeaderImageComponent = ({ resolution, imgSrc }) => {
	if (resolution === RESOLUTION.LARGE || resolution === RESOLUTION.XLARGE) {
		return (
			<ProgressiveImg
				sizes={IMG_SIZES}
				src={get(imgSrc, "desktop.src")}
				thumbnail={get(imgSrc, "desktop.thumbnail")}
			/>
		);
	} else if (resolution === RESOLUTION.MEDIUM) {
		return (
			<ProgressiveImg
				sizes={IMG_SIZES}
				src={get(imgSrc, "desktop.src")}
				thumbnail={get(imgSrc, "desktop.thumbnail")}
			/>
		);
	} else if (resolution === RESOLUTION.SMALL) {
		return (
			<ProgressiveImg
				sizes={IMG_SIZES_SMALL}
				src={get(imgSrc, "mobile.src")}
				thumbnail={get(imgSrc, "mobile.thumbnail")}
			/>
		);
	}
	return false;
};

const mapStateToProps = state => ({
	resolution: state.resolution,
});

export const ListingHeaderImage = connect(mapStateToProps)(ListingHeaderImageComponent);
